import React from "react";
import { Icon } from "zina-dogi-react";
import { UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, UncontrolledTooltip } from "reactstrap";

const Steps = ({ steps, ...others }) => {
    return (
        <div className="controls">
            {steps && steps.filter(step => step.back).length > 0 && (
                <UncontrolledDropdown setActiveFromChild>
                    <DropdownToggle caret color="primary">
                        Send backward
                    </DropdownToggle>
                    <DropdownMenu>
                        {steps
                            .filter(step => step.back)
                            .map((step, i) => {
                                const onClick = !step.disabled ? step.onClick : ev => {};
                                return (
                                    <DropdownItem id={`Popover${i}`} key={`flow_step_b_${i}`} onClick={onClick}>
                                        <div>
                                            <Icon
                                                icon="info-circle"
                                                size="lg"
                                                className="info_icon"
                                                style={{
                                                    marginRight: "8px",
                                                    visibility: step.disabled ? "visible" : "hidden"
                                                }}
                                                id={`info_icon_b_${i}`}
                                            />
                                            <UncontrolledTooltip placement="left" target={`info_icon_b_${i}`}>
                                                <h6>Problems</h6>
                                                <ul className="list-group">
                                                    {step.errors.map((item, i) => {
                                                        return <li key={`step_error_${i}`}> * {item}</li>;
                                                    })}
                                                </ul>
                                            </UncontrolledTooltip>
                                            <span style={step.disabled ? { color: "#999" } : {}}>{step.display}</span>
                                        </div>
                                    </DropdownItem>
                                );
                            })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
            <span className="flex" />
            {steps && steps.filter(step => !step.back).length > 0 && (
                <UncontrolledDropdown setActiveFromChild>
                    <DropdownToggle caret color="primary">
                        Send forward
                    </DropdownToggle>
                    <DropdownMenu>
                        {steps
                            .filter(step => !step.back)
                            .map((step, i) => {
                                const onClick = !step.disabled ? step.onClick : ev => {};
                                return (
                                    <DropdownItem id={`Popover${i}`} key={`flow_step_b_${i}`} onClick={onClick}>
                                        <div>
                                            <Icon
                                                icon="info-circle"
                                                size="lg"
                                                className="info_icon"
                                                style={{
                                                    marginRight: "8px",
                                                    visibility: step.disabled ? "visible" : "hidden"
                                                }}
                                                id={`info_icon_f_${i}`}
                                            />
                                            <UncontrolledTooltip placement="right" target={`info_icon_f_${i}`}>
                                                <h6>Problems</h6>
                                                <ul className="list-group">
                                                    {step.errors.map((item, i) => {
                                                        return <li key={`step_error_${i}`}> * {item}</li>;
                                                    })}
                                                </ul>
                                            </UncontrolledTooltip>
                                            <span style={step.disabled ? { color: "#999" } : {}}>{step.display}</span>
                                        </div>
                                    </DropdownItem>
                                );
                            })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
        </div>
    );
};

export default Steps;
